<div id="grid-wrapper" style="width: 100%">
  <ag-grid-angular
    [domLayout]="'normal'"
    [style.height]="aftersalesOverviewData.length > 20 ? '750px' : 'none'"
    [gridOptions]="gridOptions"
    [rowData]="rowData"
    [columnDefs]="columnDefs"
    [defaultColDef]="defaultColDef"
    [pagination]="false"
    [multiSortKey]="multiSortKey"
    [getContextMenuItems]="getContextMenuItems"
    [tooltipShowDelay]="tooltipShowDelay"
    [enableBrowserTooltips]="true"
    [components]="frameworkComponents"
    [excelStyles]="excelStyles"
    (gridReady)="onGridReady($event)"
    class="ag-theme-alpine_customize"></ag-grid-angular>
</div>

@if (isDetailsTabDisabled()) {
  <pas-sidebar-holder [hasNavbar]="true">
    <div class="sidebar-contents">
      <ng-container>
        <div class="sidebar-element sidebar-row">
          <ul class="navbar-nav">
            <li [ngClass]="isCreateExcelAfterSalesEnabled ? 'nav-item' : 'nav-item disabled'">
              <a (click)="onBtnCreateExcelAfterSales()" class="nav-link link-sidebar">
                <i class="material-icons">get_app</i>
                <span class="hidden-md-down" ui-test-id="excelExportBtn">{{ 'EXCEL_EXPORT' | translate }}</span>
              </a>
            </li>
            <app-tva-session-sidebar></app-tva-session-sidebar>
          </ul>
        </div>
      </ng-container>
    </div>
  </pas-sidebar-holder>
}
